import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import Testimonials from "@/components/Testimonials";
import Team from "@/components/Team";
import GroupHolding from "@/components/GroupHolding";
import Insights from "@/components/Insights";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[color:var(--bone)]" data-testid="home-page">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Services />
        <Projects />
        <Testimonials />
        <Team />
        <GroupHolding />
        <Insights />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
